import React from "react";
import ReactDOM from "react-dom/client";
import { setupIonicReact } from "@ionic/react";
import {
  iosTransitionAnimation,
  popoverEnterAnimation,
  popoverLeaveAnimation,
} from "@rdlabo/ionic-theme-ios26";
import { config } from "@/config/environment";
import App from "./App.tsx";

/* Preconnect to API domain — warms up DNS+TLS while React boots */
if (config.apiUrl) {
  const link = document.createElement("link");
  link.rel = "preconnect";
  link.href = config.apiUrl;
  link.crossOrigin = "";
  document.head.appendChild(link);
}

/* Ionic core CSS */
import "@ionic/react/css/core.css";
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";
import "@ionic/react/css/utils.bundle.css";

/* Dark mode — auto-switches based on OS preference */
import "@ionic/react/css/palettes/dark.system.css";

/* rdlabo theme CSS — iOS 26 Liquid Glass + Material Design 3 */
import "@rdlabo/ionic-theme-ios26/dist/css/default-variables.css";
import "@rdlabo/ionic-theme-ios26/dist/css/ionic-theme-ios26.css";
import "@rdlabo/ionic-theme-ios26/dist/css/ionic-theme-ios26-dark-system.css";
import "@rdlabo/ionic-theme-ios26/dist/css/md-remove-ios-class-effect.css";
import "@rdlabo/ionic-theme-md3/dist/css/ionic-theme-md3.css";

/* App theme overrides — must come after rdlabo theme */
import "./theme.css";

/* Portal component styles — Ionic-variable-based, dark-mode aware */
import "./portal.css";

/* Mode class already set on <html> by inline script in index.html — keep in sync */
const mode = document.documentElement.classList.contains("ios") ? "ios" : "md";
const isEmbed = window.location.pathname.includes("/embed");
setupIonicReact({
  mode,
  navAnimation: !isEmbed && mode === "ios" ? iosTransitionAnimation : undefined,
  popoverEnter: !isEmbed && mode === "ios" ? popoverEnterAnimation : undefined,
  popoverLeave: !isEmbed && mode === "ios" ? popoverLeaveAnimation : undefined,
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
